package websocket

import apiclient.markers.Marker
import dev.fritz2.core.RootStore
import kotlinx.coroutines.Job

class MarkerClientStore : RootStore<Map<String, Marker>>(
    initialData = emptyMap(),
    job = Job(),
) {
//    private val markersWebsocketModule: MarkersWebsocketModule = koinCtx.get()
//    private val apiUserStore: ApiUserStore by koinCtx.inject()

//    val print = SimpleHandler<Map<String, Marker>> { data, _ ->
//        data handledBy { currentData ->
//            val users = currentData.filterValues { it is Marker.UserMarker }.map { (it.value as Marker.UserMarker).userId }
//            val objects = currentData.filterValues { it is Marker.ObjectMarker }.map { (it.value as Marker.ObjectMarker).id }
//            console.log(
//                "WEBSOCKET DATA ->",
//                "UserMarkers (${users.size}):",
//                users.toString(),
//                "ObjectMarkers (${objects.size}):",
//                objects.toString(),
//            )
//        }
//    }

//    val clearOut = handle { markers ->
//        if (markers.isNotEmpty()) {
//            val oldSize = markers.size
//            val clearedOutList = markers.filter { (_, marker) ->
//                marker.tags?.getUniqueTag(MarkerTags.LocationLastUpdatedAt)?.let { time ->
//                    (Clock.System.now() - Instant.parse(time)) < 10.seconds
//                } ?: false
//            }
//            console.log("Cleared out older markers. Old size: $oldSize, new size ${clearedOutList.size}")
//            clearedOutList
//        } else markers
//    }

//    init {
    // markers is only updating at a configurable interval, check module init for details
//        markersWebsocketModule.markers
//            .map { state ->
//                val me = apiUserStore.current.userId
//                // handle users
//                state.values.filterIsInstance<Marker.UserMarker>().filter { it.userId != me }.map { marker ->
//                    marker.copy(
//                        tags = (marker.tags ?: emptyList()).setUniqueTag(
//                            MarkerTags.LocationLastUpdatedAt,
//                            Clock.System.now().toString(),
//                        ),
//                    )
//                }.associateBy { value -> value.userId } +
//                    // handle objects
//                    state.values.filterIsInstance<Marker.ObjectMarker>().map { marker ->
//                        marker.copy(
//                            tags = (marker.tags ?: emptyList()).setUniqueTag(
//                                MarkerTags.LocationLastUpdatedAt,
//                                Clock.System.now().toString(),
//                            ),
//                        )
//                    }.associateBy { value -> value.id }
//            }.also { print(it) } handledBy update

//        CoroutineScope(CoroutineName("clear-out-old-markers")).launch {
//            while (true) {
//                delay(1.minutes)
//                clearOut(Unit)
//            }
//        }
//    }
}
